module.exports = __webpack_public_path__ + "img/15_26@3x.b22b6382.png";